/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Description_PlaceholderInputs */



/**
* | output |
* | --- |
* | "What happened, or what would you like to see? Steps to reproduce help for bugs." |
*
* @param {Feedback_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_description_placeholder = /** @type {((inputs?: Feedback_Description_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Description_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Que s'est-il passé, ou que souhaiteriez-vous voir ? Les étapes de reproduction aident pour les bugs.")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Qué ocurrió o qué le gustaría ver? Los pasos para reproducirlo ayudan en el caso de errores.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O que aconteceu ou o que você gostaria de ver? Passos para reproduzir ajudam para bugs.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cosa è successo o cosa vorresti vedere? I passi per riprodurre il problema aiutano per i bug.")
	return /** @type {LocalizedString} */ ("What happened, or what would you like to see? Steps to reproduce help for bugs.")
});